import {
    Frame,
    Layout,
    Page,
    LegacyCard,
    ResourceList,
    ResourceItem,
    Pagination,
    Loading,
    EmptyState,
    Text,
} from "@shopify/polaris";
import { useEffect, useRef, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import Api from "../../helpers/api";

const ApproveCustomers = () => {
    const topElement = useRef();
    const history = useHistory();
    const [customers, setCustomers] = useState([]);
    const {search} = useLocation();
    const [loading, setLoading] = useState(true);
    const [meta, setMeta] = useState({
        current_page: (new URLSearchParams(search)).get('page') || 1,
        last_page: 1,
    });
    const [backUrl, setBackUrl] = useState(null);

    useEffect(() => {
        setLoading(true);

        Api.listUnapprovedCustomers(meta.current_page)
            .then(response => {
                setCustomers(response.data.data);
                setMeta(response.data.meta);

                const backUrlParams = new URLSearchParams({ page: response.data.meta.current_page });
                setBackUrl(`/customers/approve?${backUrlParams}`);
                setLoading(false);

                topElement.current?.scrollIntoView();
            });
    }, [meta.current_page]);

    return (
        <Frame>
            {loading && <Loading />}
            <span ref={topElement}></span>
            <Page
                title="Approve Customers"
                backAction={{ content: 'Back', onAction: () => history.goBack() }}
            >
                <Layout>
                    <Layout.Section>
                        <LegacyCard>
                            <ResourceList
                                resourceName={{ singular: 'customer', plural: 'customers' }}
                                items={customers}
                                emptyState={<EmptyState><p>No pending customers</p></EmptyState>}
                                renderItem={(item) => {
                                    return (
                                        <ResourceItem
                                            id={item.id}
                                            accessibilityLabel={`View details for account ${item.account_number}`}
                                            onClick={() => history.push(`/customers/${item.id}?back=${encodeURI(backUrl)}`)}
                                        >
                                            <h3>
                                                <Text  variant="bodyMd" as="span" fontWeight="semibold">{`#${item.account_number} - ${item.additional_data.first_name} ${item.additional_data.last_name}`}</Text>
                                            </h3>
                                            <div>{`Phone: ${item.additional_data.phone} - Email: ${item.email}`}</div>
                                        </ResourceItem>
                                    );
                                }}
                            />
                            {meta.last_page > 1 &&
                                <LegacyCard.Section>
                                    <Pagination label={`Showing Page ${meta.current_page} of ${meta.last_page}`}
                                                hasPrevious={ meta.current_page > 1}
                                                onPrevious={() => setMeta(state => ({ ...state, current_page: state.current_page - 1 }))}
                                                hasNext={ meta.current_page < meta.last_page }
                                                onNext={() => setMeta(state => ({ ...state, current_page: state.current_page + 1 }))} />
                                </LegacyCard.Section>
                            }
                        </LegacyCard>
                    </Layout.Section>
                </Layout>
            </Page>
        </Frame>
    );
}

export default ApproveCustomers;
